import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChatRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-chat',
	path: '/jira/servicedesk/projects/:projectKey/settings/chat',
	exact: true,
};
